var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullsizeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 892.62 233.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #0f223c;\n      }\n\n      .cls-3 {\n        fill: #ffd11a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    y: 0,
    width: 233.18,
    height: 233.18,
    rx: 72.23,
    ry: 72.23
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.21,37.78c-3.29-.69-6.71-1.04-10.2-1.04s-6.97.37-10.3,1.07v-.03c0-5.65,4.59-10.24,10.26-10.24s10.24,4.59,10.24,10.24Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.45,82.5h-1.29c-2.98-21.23-19.15-38.26-39.96-42.53-3.29-.69-6.71-1.04-10.2-1.04s-6.97.37-10.3,1.07c-20.73,4.28-36.87,21.31-39.84,42.5h-1.3c-18.26,0-33.21,14.94-33.21,33.21v12.59c0,2.34,1.91,4.27,4.25,4.27h12.97v-.26c0-14.55,11.8-26.35,26.35-26.35s26.35,11.8,26.35,26.35v.26h29.66v-.26c0-14.55,11.8-26.35,26.35-26.35s26.35,11.8,26.35,26.35v.26h12.74c2.34,0,4.27-1.93,4.27-4.27v-12.59c0-18.26-14.94-33.21-33.22-33.21ZM82.47,82.5c3.29-16.06,17.52-28.18,34.54-28.18s31.25,12.13,34.54,28.18h-69.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.33,132.31c0,.08,0,.17,0,.25-.13,7.83-6.52,14.14-14.38,14.14s-14.24-6.3-14.37-14.14c0-.08,0-.17,0-.25,0-7.94,6.44-14.39,14.38-14.39s14.39,6.45,14.39,14.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M172.7,132.31c0,.08,0,.17,0,.25-.13,7.83-6.52,14.14-14.38,14.14s-14.24-6.3-14.37-14.14c0-.08,0-.17,0-.25,0-7.94,6.44-14.39,14.38-14.39s14.39,6.45,14.39,14.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M117.01,199.87c-20.38,0-38.69-12.13-46.63-30.91-1.66-3.91.18-8.43,4.09-10.08,3.92-1.66,8.43.18,10.08,4.09,5.53,13.07,18.26,21.51,32.45,21.51s26.8-8.37,32.37-21.32c1.68-3.9,6.21-5.71,10.11-4.03,3.9,1.68,5.71,6.21,4.03,10.11-8,18.6-26.26,30.63-46.51,30.63Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 126.25,
    y: 66.27,
    width: 8.06,
    height: 22.82,
    rx: 3.81,
    ry: 3.81
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M327.9,34.38v56h-13.04l-24.72-29.84v29.84h-15.52v-56h13.04l24.72,29.84v-29.84h15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M376.62,79.5h-23.68l-4.4,10.88h-16.16l24.72-56h15.6l24.8,56h-16.48l-4.4-10.88ZM371.98,67.82l-7.2-17.92-7.2,17.92h14.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M452.54,90.38l-.16-29.68-14.4,24.16h-7.04l-14.32-23.36v28.88h-14.64v-56h13.04l19.68,32.32,19.2-32.32h13.04l.16,56h-14.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M528.86,90.38l-.16-29.68-14.4,24.16h-7.04l-14.32-23.36v28.88h-14.64v-56h13.04l19.68,32.32,19.2-32.32h13.04l.16,56h-14.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M592.14,79.5h-23.68l-4.4,10.88h-16.16l24.72-56h15.6l24.8,56h-16.48l-4.4-10.88ZM587.5,67.82l-7.2-17.92-7.2,17.92h14.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M637.9,62.38c0-16.8,13.2-29.12,31.12-29.12s31.12,12.32,31.12,29.12-13.2,29.12-31.12,29.12-31.12-12.32-31.12-29.12ZM684.14,62.38c0-9.68-6.64-16-15.12-16s-15.12,6.32-15.12,16,6.64,16,15.12,16,15.12-6.32,15.12-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M705.58,62.38c0-16.8,13.2-29.12,31.12-29.12s31.12,12.32,31.12,29.12-13.2,29.12-31.12,29.12-31.12-12.32-31.12-29.12ZM751.82,62.38c0-9.68-6.64-16-15.12-16s-15.12,6.32-15.12,16,6.64,16,15.12,16,15.12-6.32,15.12-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M800.62,75.5h-8.64v14.88h-15.84v-56h25.6c15.28,0,24.88,7.92,24.88,20.72,0,8.24-4,14.32-10.96,17.68l12.08,17.6h-16.96l-10.16-14.88ZM800.78,46.86h-8.8v16.4h8.8c6.56,0,9.84-3.04,9.84-8.16s-3.28-8.24-9.84-8.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M834.86,65.42v-31.04h15.84v30.56c0,9.6,4,13.44,10.64,13.44s10.56-3.84,10.56-13.44v-30.56h15.6v31.04c0,16.72-9.76,26.08-26.32,26.08s-26.32-9.36-26.32-26.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M502.22,156.4h-17.2v-12.56h50.16v12.56h-17.12v43.44h-15.84v-43.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M575.82,188.96h-23.68l-4.4,10.88h-16.16l24.72-56h15.6l24.8,56h-16.48l-4.4-10.88ZM571.18,177.28l-7.2-17.92-7.2,17.92h14.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M633.5,199.84l-11.6-17.36-11.44,17.36h-18.08l20.4-28.32-19.52-27.68h17.84l11.2,16.16,11.04-16.16h17.12l-19.52,27.04,20.8,28.96h-18.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M655.42,143.84h15.84v56h-15.84v-56Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 736.26,
    y: 167.21,
    width: 28.89,
    height: 7.22,
    rx: 2,
    ry: 2,
    transform: "translate(1501.42 341.65) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 692.9,
    y: 167.21,
    width: 36.11,
    height: 7.22,
    rx: 2,
    ry: 2,
    transform: "translate(1421.92 341.65) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 396.49,
    y: 167.21,
    width: 28.89,
    height: 7.22,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 432.63,
    y: 167.21,
    width: 36.11,
    height: 7.22,
    rx: 2,
    ry: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullsizeLogo);
export default __webpack_public_path__ + "static/media/fullsizeLogo.ef050c63a0fa91cab09df1f0e61baf6d.svg";
export { ForwardRef as ReactComponent };